import { Component } from '@angular/core';
import { ApiService } from '../api.service';
import { DomSanitizer, SafeUrl} from '@angular/platform-browser';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss']
})
export class EventsComponent {
  url:any;

  constructor(public api:ApiService,private sanitizer:DomSanitizer ){
    window.addEventListener('message', (event) => {
      document.getElementById('iframe').style.height = event.data['height'] + 20 + 'px';
      if(event.data['height'] === 0){
        document.getElementById('iframe').style.height = window.innerHeight - 200 + 'px';
      }
    });
  }

  ngOnInit() {
    console.log(this.api.user);
    //this.url = this.sanitizer.bypassSecurityTrustResourceUrl('http://localhost:4200?token='+this.api.user.value.token) ;
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl('https://events.blackrockgames.fr/?table=customer&token='+this.api.user.token+'&email='+this.api.user.email) ;
  }
}
